module.exports = __webpack_public_path__ + "media/images/Creeps_WeirdosCollection-ab88e945c7f5b6a097c6e2e33264af11.png";